export const getSelectedVal = (multiple: boolean, selectedVal: any) =>
  multiple ? selectedVal : convertSelectedValToArr(selectedVal)

export const convertSelectedValToArr = (selectedVal: any) =>
  selectedVal ? [selectedVal] : []
